import Alpine from 'alpinejs'

export default (function () {
  Alpine.data('marquee', (rate = 20) => ({
    instance: null,
    started: false,
    async init() {
      /** @type {[import('dynamic-marquee').Marquee, {import('dynamic-marquee').loop}]} */
      const [Plugin, loop] = await import('dynamic-marquee').then(mod => [mod.Marquee, mod.loop]).catch(e => console.log(e))

      const items = Array.from(this.$root.children)
      const itemsHtml = items.map(item => { const html = item.outerHTML.trim(); item.remove(); return html })

      const el = document.createElement('div')
      const builders = itemsHtml.map(html => () => {
        el.innerHTML = html
        const out = el.firstElementChild
        return out
      })

      this.instance = new Plugin(this.$root, { rate, startOnScreen: true })
      this.started = true
      loop(this.instance, builders)

      let prevScrollTop = window.pageYOffset || document.documentElement.scrollTop
      let prevScrollDirection = 1

      window.addEventListener('scroll', () => {
        if (!this.started) return

        const st = window.pageYOffset || document.documentElement.scrollTop
        if (st > prevScrollTop && prevScrollDirection !== 1) {
          // downscroll code here
          prevScrollDirection = 1
        }
        else if (st < prevScrollTop && prevScrollDirection !== -1) {
          // upscroll code
          prevScrollDirection = -1
        }
        prevScrollTop = st <= 0 ? 0 : st // for Mobile or negative scrolling

        this.instance.setRate(rate * prevScrollDirection)
      }, { passive: true })
    },
    destroy() {
      this.instance && this.instance.clear()
    },
  }))
})()



// import Alpine from 'alpinejs'
// const PERFORMANCE_HACKS = { isolation: 'isolate', backfaceVisibility: 'hidden', willChange: 'transform', force3D: true }
// // https://gsap.com/community/forums/topic/38702-marquee-animation-gsap/
// let gsap,
//   Observer = null

// export default (function () {
//   Alpine.data('marquee', function (speed, reversed = false) {
//     return {
//       async init() {
//         if (!gsap) {
//           ;[gsap, Observer] = await Promise.all([
//             import('gsap').then((mod) => mod.default),
//             import('gsap/Observer').then((mod) => mod.default),
//           ])
//           gsap.registerPlugin(Observer)
//         }

//         // Ensure GPU-friendly transforms
//         const items = Array.from(this.$root.children)
//         gsap.set(this.$root, PERFORMANCE_HACKS)
//         gsap.set(items, PERFORMANCE_HACKS)

//         // Build timeline
//         const tl = horizontalLoop(items, {
//           repeat: -1,
//           speed: speed,
//           reversed,
//           paddingRight: parseFloat(
//             gsap.getProperty(items[0], 'marginRight', 'px')
//           ), // otherwise first element would be right up against the last when it loops. In this layout, the spacing is done with marginRight.
//         })

//         // Smooth, allocation-free timeScale changes
//         const baseScale = reversed ? -1 : 1
//         const setTimeScale = gsap.quickTo(tl, 'timeScale', {
//           duration: 0.25,
//           ease: 'power1.out',
//           overwrite: 'auto',
//         })

//         Observer.create({
//           tolerance: 8,
//           onChangeY(self) {
//             const direction = self.deltaY < 0 ? -1 : 1
//             const accelTarget = 6.25 * baseScale * direction // match previous impulse (2.5 * 2.5)
//             const clamped = gsap.utils.clamp(-6, 6, accelTarget)
//             setTimeScale(clamped)
//             gsap.delayedCall(0.3, () => setTimeScale(baseScale * direction))
//           },
//         })

//         this.$root.addEventListener('mouseenter', () => {
//           setTimeScale(0)
//         })

//         this.$root.addEventListener('mouseleave', () => {
//           setTimeScale(baseScale)
//         })
//       },
//     }
//   })
// })()

// /*
// This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

// Features:
//  - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
//  - When each item animates to the left or right enough, it will loop back to the other side
//  - Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
//  - The returned timeline will have the following methods added to it:
//    - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
//    - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
//    - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
//    - current() - returns the current index (if an animation is in-progress, it reflects the final index)
//    - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
//  */
// function horizontalLoop(items, config) {
//   items = gsap.utils.toArray(items)
//   config = config || {}
//   let tl = gsap.timeline({
//       repeat: config.repeat,
//       paused: config.paused,
//       defaults: { ease: 'none' },
//       onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100),
//     }),
//     length = items.length,
//     startX = items[0].offsetLeft,
//     times = [],
//     widths = [],
//     xPercents = [],
//     curIndex = 0,
//     pixelsPerSecond = (config.speed || 1) * 100,
//     snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
//     totalWidth,
//     curX,
//     distanceToStart,
//     distanceToLoop,
//     item,
//     i
//   gsap.set(items, {
//     // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
//     xPercent: (i, el) => {
//       let w = (widths[i] = parseFloat(gsap.getProperty(el, 'width', 'px')))
//       xPercents[i] = snap(
//         (parseFloat(gsap.getProperty(el, 'x', 'px')) / w) * 100 +
//           gsap.getProperty(el, 'xPercent')
//       )
//       return xPercents[i]
//     },
//   })
//   gsap.set(items, { x: 0 })
//   totalWidth =
//     items[length - 1].offsetLeft +
//     (xPercents[length - 1] / 100) * widths[length - 1] -
//     startX +
//     items[length - 1].offsetWidth *
//       gsap.getProperty(items[length - 1], 'scaleX') +
//     (parseFloat(config.paddingRight) || 0)
//   for (i = 0; i < length; i++) {
//     item = items[i]
//     curX = (xPercents[i] / 100) * widths[i]
//     distanceToStart = item.offsetLeft + curX - startX
//     distanceToLoop =
//       distanceToStart + widths[i] * gsap.getProperty(item, 'scaleX')
//     tl.to(
//       item,
//       {
//         xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
//         duration: distanceToLoop / pixelsPerSecond,
//       },
//       0
//     )
//       .fromTo(
//         item,
//         {
//           xPercent: snap(
//             ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
//           ),
//         },
//         {
//           xPercent: xPercents[i],
//           duration:
//             (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
//           immediateRender: false,
//         },
//         distanceToLoop / pixelsPerSecond
//       )
//       .add('label' + i, distanceToStart / pixelsPerSecond)
//     times[i] = distanceToStart / pixelsPerSecond
//   }
//   function toIndex(index, vars) {
//     vars = vars || {}
//     Math.abs(index - curIndex) > length / 2 &&
//       (index += index > curIndex ? -length : length) // always go in the shortest direction
//     let newIndex = gsap.utils.wrap(0, length, index),
//       time = times[newIndex]
//     if (time > tl.time() !== index > curIndex) {
//       // if we're wrapping the timeline's playhead, make the proper adjustments
//       vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) }
//       time += tl.duration() * (index > curIndex ? 1 : -1)
//     }
//     curIndex = newIndex
//     vars.overwrite = true
//     return tl.tweenTo(time, vars)
//   }
//   tl.next = (vars) => toIndex(curIndex + 1, vars)
//   tl.previous = (vars) => toIndex(curIndex - 1, vars)
//   tl.current = () => curIndex
//   tl.toIndex = (index, vars) => toIndex(index, vars)
//   tl.times = times
//   tl.progress(1, true).progress(0, true) // pre-render for performance
//   if (config.reversed) {
//     tl.vars.onReverseComplete()
//     tl.reverse()
//   }
//   return tl
// }
